var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.315,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12038",
    fill: "#2d3e5c",
    stroke: "#707070",
    d: "M0 0h15.315v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 341",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12039",
    fill: "none",
    d: "M0 0h15.315v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15950",
    d: "M12.124 5.667H9.891l.128-1.1c.191-1.633-.128-2.933-1.149-3.233h-.1a.644.644 0 0 0-.479.4S6.062 6.667 5.105 6.667h-3.51a.653.653 0 0 0-.638.666v5.333a.653.653 0 0 0 .638.667h4.244a.5.5 0 0 1 .383.133 6.827 6.827 0 0 0 2.712 1.2h1.6c1.883 0 3.51-1.333 3.669-3.967L14.357 8a2.289 2.289 0 0 0-.624-1.682 2.089 2.089 0 0 0-1.61-.652ZM2.233 8h1.915v4H2.233Zm10.689 2.6c-.128 1.733-1.021 2.733-2.393 2.733h-1.6a6.878 6.878 0 0 1-1.942-.933 1.8 1.8 0 0 0-1.148-.4h-.415V8c.606-.133 1.6-.733 3.35-4.267a5.639 5.639 0 0 1-.032.7l-.128 1.1L8.457 7h3.669a.839.839 0 0 1 .7.247.923.923 0 0 1 .26.72Z",
    fill: "#2d3e5c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLike);
export default __webpack_public_path__ + "static/media/FB_Like.2bee1dc5ceef5eb9d0c9368a9c983965.svg";
export { ForwardRef as ReactComponent };